import moment from 'moment';
import React from 'react';

import {TIME_FORMAT_USER} from '../../../data/constants/datetime';
import {useI18n} from '../../../data/hooks/i18nHooks';
import {eventMomentFactory} from '../../../data/misc/eventMomentFactory';
import styles from './UserTimeInfo.module.scss';

const UserTimeInfo = props => {
    const {className = '', event, time, format} = props,
        eventTime = eventMomentFactory(event, time, format),
        localTime = moment(time, format).local(),
        i18n = useI18n();

    // No output needed if time is shown in user timezone
    if (event.show_in_user_timezone) return null;

    // No output needed if the same timezone/offset
    if (eventTime.utcOffset() == localTime.utcOffset()) return null;

    // Output
    const formattedTime = localTime.format(TIME_FORMAT_USER),
        date = eventTime.date() != localTime.date() ? localTime.format('ddd') : null;

    return (
        <div className={[styles.UserTimeInfo, className].join(' ')}>
            {i18n['label.in-your-timezone']}: <span className={styles.time}>{formattedTime}</span> {date ? <span className={styles.date}>({date})</span> : null}
        </div>
    );
};

export default UserTimeInfo;
